// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__35hsF","label":"CategoryService_label__jcEuw","location":"CategoryService_location__p_mGw"};